import React from 'react';
import PropTypes from 'prop-types';

/**
 * Pied de page commun aux documents imprimés du Bureau.
 *
 * REPRIS DE L'OFFRE CIMA, comme l'en-tête : un filet gris, puis les coordonnées
 * du Bureau en petit. C'est ce qui permet à un destinataire de répondre, de
 * téléphoner ou d'écrire sans avoir à chercher ailleurs : une quittance ou un
 * ordre de dépense circulent hors de l'application, souvent photocopiés.
 *
 * LES COORDONNÉES VIENNENT DU BUREAU, PAS D'UNE CONSTANTE. L'offre CIMA porte
 * l'adresse du Bureau togolais écrite en dur dans son code ; la reprendre telle
 * quelle ferait sortir les documents d'un autre bureau avec l'adresse du Togo.
 * On compose donc la ligne à partir de l'organisme, et on ne garde que ce qui
 * est renseigné.
 *
 * SI RIEN N'EST RENSEIGNÉ, ON N'AFFICHE RIEN. Un filet seul au bas d'une page se
 * lit comme un défaut d'impression.
 */
export default function PiedDocumentBncb({ bureau }) {
    const adresse = [bureau?.adresse, bureau?.boitePostale, bureau?.ville]
        .map((v) => (typeof v === 'string' ? v.trim() : ''))
        .filter(Boolean)
        .join(' - ');

    const contacts = [
        bureau?.telephonePrincipal ? `Tél : ${bureau.telephonePrincipal}` : null,
        bureau?.fax ? `Fax : ${bureau.fax}` : null,
        bureau?.email ? `Email : ${bureau.email}` : null,
        bureau?.siteWeb || null,
    ].filter(Boolean).join('  -  ');

    if (!adresse && !contacts) return null;

    return (
        <div className="bncb-pied">
            {adresse && <div>{adresse}</div>}
            {contacts && <div>{contacts}</div>}
        </div>
    );
}

PiedDocumentBncb.propTypes = {
    bureau: PropTypes.object,
};
